"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerTrack = exports.TickerText = exports.TickerItem = exports.TickerIcon = exports.TickerContent = exports.TickerContainer = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"tjbbc8j";
const TickerContainer = exports.TickerContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerContainer",
  class: "t1m3ct4j",
  vars: {
    "t1m3ct4j-0": [({
      backgroundColor
    }) => backgroundColor || '#a6fff8']
  }
});
const TickerTrack = exports.TickerTrack = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerTrack",
  class: "t1d4qri",
  vars: {
    "t1d4qri-0": [({
      delay
    }) => delay, "s"],
    "t1d4qri-1": [({
      direction
    }) => direction === 'left' ? 'normal' : 'reverse']
  }
});
const TickerContent = exports.TickerContent = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerContent",
  class: "t1phi23f"
});
const TickerItem = exports.TickerItem = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerItem",
  class: "tgmi0xl",
  vars: {
    "tgmi0xl-0": [({
      isMobile
    }) => isMobile ? '0 8px' : '0 16px'],
    "tgmi0xl-1": [({
      isMobile
    }) => isMobile ? '16px' : '20px']
  }
});
const TickerIcon = exports.TickerIcon = /*#__PURE__*/(0, _react.styled)("span")({
  name: "TickerIcon",
  class: "t16oe0oy"
});
const TickerText = exports.TickerText = /*#__PURE__*/(0, _react.styled)("span")({
  name: "TickerText",
  class: "tzu7ipq",
  vars: {
    "tzu7ipq-0": [({
      bold
    }) => bold ? '850' : '450']
  }
});